// extracted by mini-css-extract-plugin
export var createdDate = "_me-1";
export var divider = "_me-2";
export var headerDivider = "_me-3";
export var messagesCard = "_me-0";
export var messagesContainer = "_me-7";
export var messagesContainerWrapper = "_me-4";
export var pointerCapturingButtonBoxes = "_me-a";
export var showLeftPanelButton = "_me-9";
export var showMoreButton = "_me-c";
export var showMoreButtonContainer = "_me-b";
export var summaryTitle = "_me-6";
export var systemMessageCardWrapper = "_me-d";
export var topButtons = "_me-8";
export var withPadding = "_me-5";